var map = {
	"./1893/01_full.jpg": "e98b",
	"./1893/02_full.jpg": "97f8",
	"./1893/03_full.jpg": "bec1",
	"./1893/04_full.jpg": "8e63",
	"./1893/05_full.jpg": "77960",
	"./1893/06_full.jpg": "f281",
	"./1893/07_full.jpg": "d035",
	"./1893/08_full.jpg": "144a",
	"./1925/01_full.jpg": "7a5e",
	"./1925/02_full.jpg": "b367",
	"./1925/03_full.jpg": "ad35",
	"./1925/04_full.jpg": "5aa2",
	"./1925/05_full.jpg": "5403",
	"./1925/06_full.jpg": "70b1",
	"./1949/01_full.jpg": "bec2",
	"./1949/02_full.jpg": "29a5",
	"./1949/03_full.jpg": "cda1",
	"./1949/04_full.jpg": "3376",
	"./1951/01_full.jpg": "10cf",
	"./1951/02_full.jpg": "0ffd",
	"./1951/03_full.jpg": "0a5b",
	"./1956/01_full.jpg": "299b",
	"./1956/02_full.jpg": "994b",
	"./1956/03_full.jpg": "a271",
	"./1960/01_full.jpg": "a2ae",
	"./1960/02_full.jpg": "4d24",
	"./1960/03_full.jpg": "ed97",
	"./1960/04_full.jpg": "8423",
	"./1982/01_full.jpg": "4ad2",
	"./1982/02_full.jpg": "8cfc",
	"./1982/03_full.jpg": "beea",
	"./1993/01_full.jpg": "fbff",
	"./1993/02_full.jpg": "2a65",
	"./1993/03_full.jpg": "8022",
	"./1993/04_full.jpg": "30bd",
	"./1993/05_full.jpg": "cf55",
	"./1993/06_full.jpg": "fe1f",
	"./1993/07_full.jpg": "2135",
	"./1993/08_full.jpg": "87e0",
	"./1993/09_full.jpg": "696e",
	"./2016/01_full.jpg": "0841",
	"./2016/02_full.jpg": "7b3e",
	"./2016/03_full.jpg": "356c",
	"./2016/04_full.jpg": "1a86",
	"./2016/05_full.jpg": "830f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "76dc";